export const MAX_LEN_CLASS_NAME = 15;
